import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_wlUgE7otqhKd: {
	id: 'prd_wlUgE2DEV27otqhKd'
	ident: 'prd_wlUgE7otqhKd'
	sku: 'simple_premium_12w_25_99_12w_66_65_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: 1
			price_id: 'prc_sUfuR2DEV2EIFlcS9'
			amount: 66.65
			amount_usd: 25.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 25.99
			discount: 40.66
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: null
			price_id: 'prc_aZ0un2DEV2YsfzbXN'
			amount: 66.65
			amount_usd: 66.65
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_wlUgE7otqhKd, SubscriptionProduct>
const prd_wlUgE7otqhKd = { ident: 'prd_wlUgE7otqhKd' } as typeof _prd_wlUgE7otqhKd

export default prd_wlUgE7otqhKd
